import { render, staticRenderFns } from "./UserRequestDetailView.vue?vue&type=template&id=65ce7c63"
import script from "./UserRequestDetailView.vue?vue&type=script&lang=js"
export * from "./UserRequestDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports